export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fa02c770f90ed4f74bce50b5a50ada7eea553619c&name=fetchTypeahead!'